import React from 'react'
import { Image, Section } from '../../../components'
import { STRING } from '../../../helpers'
import { ICONS } from '../../../themes'

const Title = () => {
  return (
    <Section className="auction-title">
      <Section className="logo-wrapper">
        <Image src={ICONS['icon-hammer-white.svg']} className="icon-hammer" />
      </Section>
      {STRING.AUCTION_DASHBOARD}
    </Section>
  )
}

export default Title
